var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SingleView',_vm._b({},'SingleView',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }